<script>
  import IconButton from './IconButton.svelte';

  export let value;
  export let label = undefined;
  export let placeholder = undefined;
  export let disabled = false;
  export let actions = false;
  export let focus = true;
  export let error = undefined;
  export let translate = undefined;
  export let onTranslateClick = undefined;
  export let characters = undefined;
  export let height = '320px';

  let textarea;

  function bold () {
    textarea.focus();

    value = textarea.value;

    const startPosition = textarea.selectionStart;
    const endPosition = textarea.selectionEnd;

    if (value.substring(startPosition - 2, startPosition) === '**' && value.substring(endPosition, endPosition + 2) === '**') {
      value = value.substring(0, startPosition - 2) + value.substring(startPosition, endPosition) + value.substring(endPosition + 2, value.length);
      textarea.value = value;
      // eslint-disable-next-line no-magic-numbers
      textarea.setSelectionRange(startPosition - 2, endPosition - 2);
    } else if (startPosition === endPosition) {
      value = value.substring(0, startPosition) + '**bold**' + value.substring(endPosition, value.length);
      textarea.value = value;
      // eslint-disable-next-line no-magic-numbers
      textarea.setSelectionRange(startPosition + 2, endPosition + 6);
    } else {
      value = value.substring(0, startPosition) + '**' + value.substring(startPosition, endPosition) + '**' + value.substring(endPosition, value.length);
      textarea.value = value;
      // eslint-disable-next-line no-magic-numbers
      textarea.setSelectionRange(startPosition + 2, endPosition + 2);
    }
  }

  function italic () {
    textarea.focus();

    value = textarea.value;

    const startPosition = textarea.selectionStart;
    const endPosition = textarea.selectionEnd;

    if (value.substring(startPosition - 1, startPosition) === '_' && value.substring(endPosition, endPosition + 1) === '_') {
      value = value.substring(0, startPosition - 1) + value.substring(startPosition, endPosition) + value.substring(endPosition + 1, value.length);
      textarea.value = value;
      // eslint-disable-next-line no-magic-numbers
      textarea.setSelectionRange(startPosition - 1, endPosition - 1);
    } else if (startPosition === endPosition) {
      value = value.substring(0, startPosition) + '_italic_' + value.substring(endPosition, value.length);
      textarea.value = value;
      // eslint-disable-next-line no-magic-numbers
      textarea.setSelectionRange(startPosition + 1, endPosition + 7);
    } else {
      value = value.substring(0, startPosition) + '_' + value.substring(startPosition, endPosition) + '_' + value.substring(endPosition, value.length);
      textarea.value = value;
      // eslint-disable-next-line no-magic-numbers
      textarea.setSelectionRange(startPosition + 1, endPosition + 1);
    }
  }

  function link () {
    textarea.focus();

    value = textarea.value;

    const startPosition = textarea.selectionStart;
    const endPosition = textarea.selectionEnd;

    if (startPosition === endPosition) {
      value = value.substring(0, startPosition) + '[link_alt](https://www.example.com)' + value.substring(endPosition, value.length);
      textarea.value = value;
      // eslint-disable-next-line no-magic-numbers
      textarea.setSelectionRange(startPosition + 1, endPosition + 9);
    } else {
      value = value.substring(0, startPosition) + '[' + value.substring(startPosition, endPosition) + '](https://www.example.com)' + value.substring(endPosition, value.length);
      textarea.value = value;
      // eslint-disable-next-line no-magic-numbers
      textarea.setSelectionRange(startPosition + 1, endPosition + 1);
    }
  }

  function image () {
    textarea.focus();

    value = textarea.value;

    const startPosition = textarea.selectionStart;
    const endPosition = textarea.selectionEnd;

    if (startPosition === endPosition) {
      value = value.substring(0, startPosition) + '![image_alt](image_id)' + value.substring(endPosition, value.length);
      textarea.value = value;
      // eslint-disable-next-line no-magic-numbers
      textarea.setSelectionRange(startPosition + 2, endPosition + 11);
    } else {
      value = value.substring(0, startPosition) + '![' + value.substring(startPosition, endPosition) + '](image_id)' + value.substring(endPosition, value.length);
      textarea.value = value;
      // eslint-disable-next-line no-magic-numbers
      textarea.setSelectionRange(startPosition + 2, endPosition + 2);
    }
  }

  function video () {
    textarea.focus();

    value = textarea.value;

    const startPosition = textarea.selectionStart;
    const endPosition = textarea.selectionEnd;

    if (startPosition === endPosition) {
      value = value.substring(0, startPosition) + '?[video_alt](video_id)' + value.substring(endPosition, value.length);
      textarea.value = value;
      // eslint-disable-next-line no-magic-numbers
      textarea.setSelectionRange(startPosition + 2, endPosition + 11);
    } else {
      value = value.substring(0, startPosition) + '?[' + value.substring(startPosition, endPosition) + '](video_id)' + value.substring(endPosition, value.length);
      textarea.value = value;
      // eslint-disable-next-line no-magic-numbers
      textarea.setSelectionRange(startPosition + 2, endPosition + 2);
    }
  }
</script>

<div class='textarea'
  class:textarea-with-actions={actions && !disabled}
  class:textarea-no-focus={!focus}
  class:textarea-with-error={error}
  style='--text-area-height: {height};'>

  {#if label} <div class='textarea-label'> {label} </div> {/if}

  {#if translate} <div class='textarea-translate' on:click={onTranslateClick}> {translate} </div> {/if}

  <textarea bind:this={textarea} bind:value={value} placeholder={placeholder} disabled={disabled}/>

  {#if actions && !disabled}
    <div class='textarea-actions'>
      {#if actions === true || actions.includes('bold')} <IconButton icon='format_bold' onClick={bold}/> {/if}
      {#if actions === true || actions.includes('italic')} <IconButton icon='format_italic' onClick={italic}/> {/if}
      {#if actions === true || actions.includes('link')} <IconButton icon='link' onClick={link}/> {/if}
      {#if actions === true || actions.includes('image')} <IconButton icon='photo_library' onClick={image}/> {/if}
      {#if actions === true || actions.includes('video')} <IconButton icon='video_library' onClick={video}/> {/if}
    </div>
  {/if}

  {#if characters} <div class='textarea-characters'> {value?.length || 0} / {characters} </div> {/if}

  {#if error} <div class='textarea-error'> {error.replace(/ ".+" /, ' ')} </div> {/if}
</div>

<style>
  .textarea {
    position: relative;

    width: 100%;
  }

  .textarea-label {
    position: absolute;
    top: -7px;
    left: 10px;

    display: flex;
    align-items: center;

    height: 15px;

    padding: 0px 5px;

    border-radius: 2px;

    font-size: 12px;
    font-weight: 550;

    background: var(--white);
    color: var(--grey-9);
  }

  .textarea-translate {
    position: absolute;
    top: -7px;
    right: 10px;

    display: flex;
    align-items: center;

    height: 15px;

    padding: 0px 5px;

    border-radius: 2px;

    text-transform: uppercase;
    text-decoration: underline;
    text-decoration-thickness: 1px;
    text-decoration-color: transparent;

    font-size: 12px;
    font-weight: 550;

    letter-spacing: 1.2px;

    background: var(--white);
    color: var(--blue-8);

    cursor: pointer;

    transition: text-decoration-color 0.25s ease-in-out;
  }

  .textarea-translate:hover {
    text-decoration-color: var(--blue-8);
  }

  .textarea textarea {
    width: 100%;
    height: var(--text-area-height);

    padding: 9px 14px;

    margin: 0px;

    box-sizing: border-box;
    border: 1px solid var(--grey-5);
    border-radius: 5px;

    font-family: var(--font-primary);
    font-size: 16px;

    background: var(--white);

    outline: none;
    resize: none;

    transition: border 0.25s ease-in-out;

    --tw-ring-color: transparent;
  }

  .textarea:not(.textarea-no-focus):not(.textarea-with-error) textarea:focus {
    border: 1px solid var(--grey-9);
  }

  .textarea textarea:disabled {
    background: var(--grey-1);
    color: var(--grey-5);
  }

  .textarea-actions {
    position: absolute;
    bottom: 0px;
    right: 0px;

    display: flex;
    flex-direction: column;
    gap: 10px;

    padding: 10px;

    color: var(--grey-9);
  }

  .textarea-characters {
    position: absolute;
    bottom: -7px;
    left: 10px;

    display: flex;
    align-items: center;

    height: 15px;

    padding: 0px 5px;

    border-radius: 2px;

    font-size: 12px;
    font-weight: 550;

    background: var(--white);
    color: var(--grey-5);

    transition: color 0.25s ease-in-out;
  }

  textarea:focus + .textarea-characters {
    color: var(--grey-9);
  }

  .textarea-error {
    position: absolute;
    bottom: -7px;
    right: 10px;

    display: flex;
    align-items: center;

    height: 15px;
    max-width: calc(100% - 30px);

    padding: 0px 5px;

    border-radius: 2px;

    font-size: 12px;
    font-weight: 550;

    background: var(--white);
    color: var(--red-8);

    overflow: hidden;

    white-space: nowrap;
  }

  .textarea-with-actions textarea {
    padding-right: 40px;
  }

  .textarea-with-error textarea {
    border: 1px solid var(--red-8);
  }

  ::placeholder {
    color: var(--grey-5);

    opacity: 1;
  }

  :global(body.dark) .textarea-label {
    background: var(--grey-9);
    color: var(--grey-4);
  }

  :global(body.dark) .textarea-translate {
    background: var(--grey-9);
    color: var(--blue-3);
  }

  :global(body.dark) .textarea-translate:hover {
    text-decoration-color: var(--blue-3);
  }

  :global(body.dark) .textarea textarea {
    border: 1px solid var(--grey-6);

    background: var(--grey-9);
    color: var(--grey-3);
  }

  :global(body.dark) .textarea:not(.textarea-no-focus):not(.textarea-with-error) textarea:focus {
    border: 1px solid var(--grey-4);
  }

  :global(body.dark) .textarea textarea:disabled {
    background: var(--grey-8);
    color: var(--grey-6);
  }

  :global(body.dark) .textarea-actions {
    color: var(--grey-4);
  }

  :global(body.dark) .textarea-characters {
    background: var(--grey-9);
    color: var(--grey-6);
  }

  :global(body.dark) textarea:focus + .textarea-characters {
    color: var(--grey-4);
  }

  :global(body.dark) .textarea-error {
    background: var(--grey-9);
    color: var(--red-3);
  }

  :global(body.dark) .textarea-with-error textarea {
    border: 1px solid var(--red-3);
  }

  :global(body.dark) ::placeholder {
    color: var(--grey-6);
  }
</style>
